import { actionTypesEnum } from '../enum';

export const allActividadesReducer = (state = null, action) => {

    if(action.type === actionTypesEnum.getAllActividades){
      return action.payload;
    }

     return state;
};

export const actividadesReducer = (state = null, action) => {

    if(action.type === actionTypesEnum.getActividades){
      return action.payload;
    }

     return state;
};